import { useAuthStore } from '@/stores/auth'
import { refreshApiCall } from '@/api/auth'
import { adaptResponseForClient } from '@/utils/adaptResponseForClient'
import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

let refreshPromise: Promise<unknown> | null = null

axios.interceptors.request.use(async config => {
  if (config && config.headers) {
    config.baseURL = BASE_URL
    const authStore = useAuthStore()

    if (authStore.isAuth) {
      config.headers.Authorization = `${authStore.tokenType} ${authStore.token}`
    }
  }
  return config
})

axios.interceptors.response.use(undefined, async error => {
  const authStore = useAuthStore()
  const originalRequest = error.config

  if (axios.isCancel(error) || !error.response || originalRequest.url.includes('/chief/refresh')) {
    return Promise.reject(error)
  }

  if (error.response.status === 401 && authStore.isAuth && !originalRequest._retry) {
    originalRequest._retry = true

    if (refreshPromise) {
      await refreshPromise
      originalRequest.headers['Authorization'] = `${authStore.tokenType} ${authStore.token}`
      return axios(originalRequest)
    }

    refreshPromise = (async () => {
      try {
        const res = await refreshApiCall(`${authStore.tokenType} ${authStore.refreshToken}`)
        console.log('🔄 Token refreshed')
        localStorage.removeItem(`user_${authStore.token}`)
        localStorage.removeItem(`tokenType_${authStore.token}`)
        authStore.writeData(adaptResponseForClient(res))
      } catch (err) {
        console.warn('❌ Refresh failed, logging out')
        authStore.clearStore()
        window.location.href = '/login'
        throw err
      } finally {
        refreshPromise = null
      }
    })()

    await refreshPromise

    originalRequest.headers['Authorization'] = `${authStore.tokenType} ${authStore.token}`
    return axios(originalRequest)
  }

  return Promise.reject(error)
})
